import styles from './category.module.scss';
import RightsWrapper from 'libs/webkua-lib/src/lib/rights-wrapper/rights-wrapper';
import { useState } from 'react';
import { ValueFormatterParams } from 'ag-grid-community';
import { useCourseGetRequestHook } from 'libs/webkua-lib/src/lib/requestUtils';
import { CreateHeaders, ErrorButton, HeaderSizeEnum, Icon, PrimaryButton, textHeader } from '@frontend-workspace/react-shared-lib';
import { ICategory } from 'libs/webkua-lib/src/lib/_models/category';
import CreateNewCategoryDialog from './create-new-category-dialog/create-new-category-dialog';
import DeleteCategoryDialog from './delete-category-dialog/delete-category-dialog';
import WebkuaTable from '../../../webkua-table/webkua-table';
import CategorySkeleton from './category-skeleton';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface CategoryProps { }

export function Category(props: CategoryProps) {
  const { data: categories, isLoading, getData: getCategories }: { data: ICategory[], isLoading: boolean, getData: () => void } = useCourseGetRequestHook(`resource/categories`, []);

  const { t } = useTranslation();
  const [isNewCategoryOpen, setIsNewCategoryOpen] = useState(false);
  const [deleteCategory, setDeleteCategory] = useState<ICategory | undefined>(undefined);

  const toggleNewCategoryOpen = () => setIsNewCategoryOpen(!isNewCategoryOpen);

  const openDeleteCategoryDialog = (e: any) => setDeleteCategory(e.data);
  const closeDeleteCategoryDialog = () => setDeleteCategory(undefined);

  const deleteRenderer = (params: ValueFormatterParams) => {
    return (
      <ErrorButton
        variant="outlined"
        size='small'
        onClick={() => openDeleteCategoryDialog(params)}>
        {t('standard.delete')}
      </ErrorButton>
    );
  };

  return (<>
    <RightsWrapper>
      <div className='mb-3'>
        <PrimaryButton
          variant="contained"
          onClick={toggleNewCategoryOpen}>
          <Icon className="me-1" fontSize="small">add</Icon>{t('standard.newCategory')}
        </PrimaryButton>
      </div>
    </RightsWrapper>
    {isLoading ? <CategorySkeleton /> :
      <WebkuaTable
        data={categories}
        headers={CreateHeaders([
          textHeader("name", t('standard.name'), HeaderSizeEnum.EXTRA_LARGE),
          textHeader("", "", HeaderSizeEnum.MEDIUM, {
            renderer: deleteRenderer,
            cellStyle: { justifyContent: 'right' },
            headerClass: "ag-right-aligned-header"
          })
        ])}
      />}
    {isNewCategoryOpen && <CreateNewCategoryDialog
      onClose={toggleNewCategoryOpen}
      open={!!isNewCategoryOpen}
      refreshData={getCategories}
    />}
    {deleteCategory && <DeleteCategoryDialog
      onClose={closeDeleteCategoryDialog}
      open={!!deleteCategory}
      refreshData={getCategories}
      categoryId={deleteCategory.id}
    />}
  </>);
}

export default Category;
